import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router
} from '@angular/router';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (
  route,
  state
) => {

  const auth =
    inject(AuthService);

  const router =
    inject(Router);
// console.log({"auth.isLoggedIn()": auth.isLoggedIn()})
  if (auth.isLoggedIn()) {
    return true;
  }

  return router.createUrlTree(
    ['/auth/signin'],
    {
      queryParams: {
        redirect: state.url
      }
    }
  );
};